import './App.css';
import FormAppLandingPage from './FormAppLandingPage';

function App() {
  return <FormAppLandingPage />;
}

export default App;
